var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 151.78 225.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4,.cls-9{fill-rule:evenodd;}.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#d8dde3;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 65.9,
    y1: 224.24,
    x2: 84.48,
    y2: 147.35,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 226.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfd4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4dc",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 17.23,
    y1: 153.78,
    x2: -1.2,
    y2: 153.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 226.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfd4dc",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 134.55,
    y1: 153.58,
    x2: 152.98,
    y2: 153.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 75.89,
    y1: 132.14,
    x2: 75.89,
    y2: 0.84,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 226.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 40.57,
    y1: 81.16,
    x2: 118.94,
    y2: 80.01,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 226.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d9aa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d9aa9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 40.58,
    y1: 81.85,
    x2: 118.95,
    y2: 80.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 40.17,
    y1: 54.23,
    x2: 118.54,
    y2: 53.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 75.12,
    y1: 188.2,
    x2: 76.25,
    y2: 111.77,
    xlinkHref: "#linear-gradient-5"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "misc-item-new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.89,4.66A26.17,26.17,0,0,0,49.82,30.92V60.06a2.33,2.33,0,1,1-4.66,0V30.92a30.73,30.73,0,1,1,61.46,0V60.06a2.33,2.33,0,1,1-4.66,0V30.92A26.16,26.16,0,0,0,75.89,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.62,50.75H134.09V94.83H18.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.62,50.75V94.92H0L9.31,80.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.16,50.75V95.33h18.62v-.41l-9.31-14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,94.52H151.78V201.81a24,24,0,0,1-24,24H24a24,24,0,0,1-24-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.63,146.24a1.73,1.73,0,0,1,.91-1.56,14.55,14.55,0,0,1,6.14-1.74,13.79,13.79,0,0,1,6,1.74,1.72,1.72,0,0,1,.88,1.53,2.32,2.32,0,0,1-3.13,2,11.47,11.47,0,0,0-3.81-.74,11.71,11.71,0,0,0-3.9.76A2.31,2.31,0,0,1,45.63,146.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.12,146.24a1.73,1.73,0,0,1,.91-1.56,14.55,14.55,0,0,1,6.14-1.74,13.75,13.75,0,0,1,6,1.74,1.72,1.72,0,0,1,.88,1.53,2.32,2.32,0,0,1-3.13,2,11.47,11.47,0,0,0-3.81-.74,11.71,11.71,0,0,0-3.9.76A2.31,2.31,0,0,1,93.12,146.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M59.91,178.06a30.36,30.36,0,0,1,14.53-6.68c6-.9,12.82.36,19,6.58a2,2,0,1,0,2.82-2.82c-7.22-7.23-15.33-8.78-22.46-7.71A34.13,34.13,0,0,0,57.3,175a2,2,0,1,0,2.61,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M75.89,41.9A31.66,31.66,0,0,0,44.23,73.56V108.2a2.33,2.33,0,1,1-4.66,0V73.56a36.32,36.32,0,0,1,72.64,0V108.2a2.33,2.33,0,1,1-4.66,0V73.56A31.66,31.66,0,0,0,75.89,41.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem);
export default __webpack_public_path__ + "static/media/item.4e4774f3b18831456399490e79b7ea55.svg";
export { ForwardRef as ReactComponent };